import { ModalName } from '../enums';

export const ModalNames = [
  ModalName.ADD_DEVICES,
  ModalName.AKTIIA_STATUS,
  ModalName.BP_CLASS,
  ModalName.CHANGE_USER_ROLE,
  ModalName.CONTACT_SUPPORT,
  ModalName.CREATE_USER,
  ModalName.DELETE_USER,
  ModalName.EDIT_ACCOUNT,
  ModalName.FEATURE_FEEDBACK,
  ModalName.INVITE_PATIENT,
  ModalName.LEAR_MORE,
  ModalName.LEAR_MORE_ABOUT_CUFF,
  ModalName.ORDER_DEVICES,
  ModalName.REMOVE_DEVICE,
  ModalName.SEND_FEEDBACK,
];
